export const STUDY_MONITORING_ACCESS = ['DFCDFC', 'dfct', 'quick', '10001']
export const POINTS_ACCESS = ['DFCDFC', 'dfct', 'quick']

export function hasOptedForPoints(user) {
    return POINTS_ACCESS.indexOf(user?.orgCode.toString()) != -1
}